// Module
var code = "<record-grid columns=\"stateController.columns\" datasource=\"stateController.gridDatasource\" grid-settings=\"stateController.gridSettings\" default-sort=\"'ProgressiveDailyPeriodDate,ProgressiveDefinitionGameDescription,ProgressiveDefinitionGameLevelName,CreatedDate'\" default-query=\"stateController.defaultQuery\"> </record-grid> ";
// Exports
export default code;